export default __webpack_public_path__ + "static/figma-save-version-a6104c4fb8b83266f2e576f05e9b0566.gif";